import { render, staticRenderFns } from "./BrownianMotionViz.vue?vue&type=template&id=52df63a9&scoped=true"
import script from "./BrownianMotionViz.vue?vue&type=script&lang=js"
export * from "./BrownianMotionViz.vue?vue&type=script&lang=js"
import style0 from "./BrownianMotionViz.vue?vue&type=style&index=0&id=52df63a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df63a9",
  null
  
)

export default component.exports